var map = {
	"./2023-06-21-lopen-des-glénan-une-compétition-mythique-de-pêche-du-bar.json": "d730",
	"./2023-06-21-open-des-glénan-2022-des-conditions-musclées.json": "e2db",
	"./2023-06-21-pêche-au-bar-participez-à-la-prochaine-édition-de-lopen-des-glénan.json": "f0cb",
	"./2023-06-28-12ème-open-des-glénan-127-équipages-et-443-poissons-pêchés.json": "2660"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba68";